import {useInvertedSurface} from '@hconnect/common/styles'
import {BackToLink, PageTitle} from '@hconnect/uikit'
import {Button} from '@hm/fundamental'
import {mdiCheck} from '@mdi/js'
import {Stack} from '@mui/material'
import React from 'react'
import {useNavigate} from 'react-router'

import {useWidgetTranslation} from '../hooks'

export type ChecklistPageHeaderProps = {
  title?: string
  backButtonProps?: {
    targetName: string
    target: string
    onNavigate?: (target: string) => void
  }
  afterTitle?: React.ReactNode
  actions?: React.ReactNode
  onSubmitClick?: () => void
  isSubmitting?: boolean
}

export const ChecklistPageHeader = React.memo<ChecklistPageHeaderProps>(
  ({title, backButtonProps, onSubmitClick, isSubmitting = false}) => {
    const {t} = useWidgetTranslation()
    const navigate = useNavigate()
    const inverted = useInvertedSurface()
    const textColor = inverted ? 'primary.contrastText' : 'text.primary'

    return (
      <>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          justifyContent={'space-between'}
          flexWrap="wrap"
          mb={{xs: 2, sm: 3}}
          gap={1}
        >
          <Stack mr="auto">
            {backButtonProps && (
              <BackToLink
                target={backButtonProps.target}
                targetName={backButtonProps.targetName}
                navigate={backButtonProps.onNavigate ?? navigate}
              />
            )}
            <PageTitle
              mx={3}
              mb={!backButtonProps ? 2 : 0}
              sx={{display: 'inline-flex', alignItems: 'center'}}
              data-test-id="page-title"
              color={textColor}
            >
              {title}
            </PageTitle>
          </Stack>
          <Stack direction="row" spacing={1}>
            {onSubmitClick && (
              <Button
                size="regular"
                icon={mdiCheck}
                onClick={onSubmitClick}
                disabled={isSubmitting}
                data-test-id="checklist-header-submit-button"
              >
                {t('button.submitChecklist')}
              </Button>
            )}
          </Stack>
        </Stack>
      </>
    )
  }
)
